import { render, staticRenderFns } from "./UnavailablePage.vue?vue&type=template&id=def90b58&scoped=true&"
import script from "./UnavailablePage.vue?vue&type=script&lang=js&"
export * from "./UnavailablePage.vue?vue&type=script&lang=js&"
import style0 from "./UnavailablePage.vue?vue&type=style&index=0&id=def90b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def90b58",
  null
  
)

export default component.exports